import { numberColumn } from '@/shared/grids/columns/numberColumn';
import { pluralSuffixTemplate } from '@/shared/utils/grid';

export const pendingRequestCountColumn = <T extends { pendingRequestCount: number }>() =>
  numberColumn<T>({
    field: 'pendingRequestCount',
    header: 'Portal Requests Pending',
    positiveSuffix: pluralSuffixTemplate<T>(' pending request', 'pendingRequestCount'),
    zeroText: 'None',
    allowFiltering: false,
    width: 150,
    visible: false,
  });
